export const FR = {
    navigation: {
        recents: 'Récents',
        dialpad: 'Clavier',
        contacts: 'Contacts',
        settings: 'Réglages'
    },
    account: 'Mon Compte',
    call_preferences: "Préférences d'appel",
    change_password: 'Changer le mot de passe',
    conference: 'Conférence',
    transfer_call: "Transférer l'appel",
    add_call: 'Ajouter un appel',
    help: 'Aider',
    about: "À propos de l'application",
    sound_and_devices: 'Sons et périphériques',
    logout: 'Déconnexion',
    search_contact: 'Rechercher',
    connectionstate: {
        connecting: 'De liaison...',
        registering: 'Enregistrement...',
        available: 'Disponible',
        unavailable: 'Indisponible',
        disconnected: 'Déconnecté',
        connected: 'Connecté'
    },
    no_results: 'Aucun résultat',
    unassigned: 'Non attribué',
    call_now: 'Appelle',
    transfer_now: 'Transférer',
    confirm_transfer: "Voulez-vous transférer l'appel vers",
    call_status: {
        finished: 'Terminé',
        trying: 'Essayer...',
        incoming: 'Entrant..',
        calling: 'Appeler...',
        hold: 'Attente'
    },
    hold: 'suspendre',
    mute: 'silence',
    confirm: 'Confirmer',
    transfer: 'transfert',
    merge: 'fusionner',
    add: 'ajouter',
    keypad: 'clavier',
    swap: 'échanger',
    lead: 'plomb',
    disable_recording: 'Arrêter enreg.',
    enable_recording: 'Démarrer enreg.',
    transfer_to: "Transférer l'appel vers",
    add_to: 'Ajouter un nouvel appel à',
    hide: 'masquer',
    talk_first: "Appelez d'abord",
    extensions_domain: 'Extensions et Domaine',
    account_info: 'Informations de compte',
    update: 'Soumettre',
    old_pass_ph: 'Ancien mot de passe',
    new_pass_ph: 'Nouveau mot de passe',
    confirm_pass_ph: 'Confirmez le mot de passe',
    sound_notifications: 'Notifications sonores',
    ringtone: 'Sonnerie',
    speakers: 'Haut-parleurs',
    output: 'Production',
    ringing_device: 'Appareil de sonnerie',
    microphone: 'Microphone',
    default: 'Défaut',
    default_device: 'Défaut',
    keyboard_shortcuts: {
        enter_pickup: 'Appuyez sur «Entrée» pour ramasser',
        esc_decline: 'Appuyez sur «Echap» pour refuser',
        esc_hangup: 'Appuyez sur «Echap» pour raccrocher',
        title: 'Raccourcis clavier'
    },
    help_items: {
        chat: 'Discute avec nous',
        report: 'Signaler un problème'
    },
    email: 'Adresse électronique',
    password: 'Mot de passe',
    login: "S'identifier",
    forgot_password: 'Mot de passe oublié',
    cancel: 'Annuler',
    reset_password: 'Réinitialiser le mot de passe',
    enter_name: 'Fournir un nom',
    info: 'info',
    private: 'Privé',
    int_connection_lost: 'Connexion Internet perdue!',
    int_connnection_lost_desc:
        "Votre ordinateur semble être hors ligne. Nous continuerons d'essayer de nous reconnecter.",
    no_contacts: 'Vous n’avez pas encore de contacts',
    mic_requirted: 'Accès au microphone requis!',
    mic_requirted_desc: "Connectez le microphone et/ou accordez au navigateur l'autorisation de l'utiliser!",
    restart_app: "Redémarrez l'appli",
    password_must: 'Le mot de passe doit contenir',
    password_recovery_strength: 'au moins une lettre minuscule, une lettre majuscule et un chiffre',
    no_recents: "Vous n'avez aucun appel récent.",
    no_recents_msg: 'Faites le premier appel!',
    listening: 'Vous écoutez',
    now: 'maintenant',
    ws_disconnection: "Déconnexion du réseau téléphonique, nous continuerons d'essayer de nous reconnecter",
    ws_reconnection_failed:
        "L'application n'a pas pu se reconnecter au serveur, corrigez votre connexion et rechargez l'application, veuillez",
    language: 'Langue',
    select: 'Choisir',
    nothing_selected: 'Rien de sélectionné',
    numberValidationError: "Le numéro n'est pas valide!",
    countryNumberValidationError: "Le numéro de pays fourni n'est pas valide!",
    sessionExpired: 'La session a expiré',
    auto_reject: "Rejet automatique pendant l'appel",
    auto_reject_tooltip: 'Rejeter les appels entrants automatiquement tout en étant occupé sur un autre appel',
    general: 'Généraux',
    field_required: 'Le champ est requis',
    password_validation: {
        lowercase: 'Le mot de passe doit contenir au moins une lettre minuscule',
        uppercase: 'Le mot de passe doit contenir au moins une lettre majuscule',
        digit: 'Le mot de passe doit contenir au moins un chiffre',
        length: 'Le mot de passe doit comporter au moins 8 caractères',
        confirmation: 'Les mots de passe ne correspondent pas'
    },
    email_incorrect: "L'adresse e-mail fournie est incorrecte",
    version: 'Version',
    auto_pickup: 'Click2Call automatique',
    auto_pickup_tooltip: "Lance l'appel automatiquement lorsqu'un Click2Call est effectué par l'utilisateur",
    notification: {
        call_to: 'Appel à',
        incoming_call: 'Appel entrant',
        tab_focus: "Mettre l'accent sur l'onglet actif",
        tab_focus_desc: "Cliquez sur la notification pour ouvrir l'application"
    },
    multipleTabsTitle: 'Les onglets multiples ne sont pas autorisés!',
    multipleTabsDescription: "On dirait que l'application est déjà ouverte dans un autre onglet/fenêtre du navigateur.",
    focusActive: 'Onglet Focus',
    forceActive: "Forcer l'activation",
    inbound_call: 'Appel entrant',
    codecs: 'Codecs',
    codecsDescription:
        'Cocher les cases pour activer/désactiver les codecs. Glisser déposer les codecs pour déterminer la priorité. (Haute position - Haute priorité)',
    codecName: 'Nom',
    codecRate: 'Fréquence / Canaux',
    hertz: 'Hz',
    open_lead_at: 'Ouvrez le contact sur',
    caller_insights: 'Contact en temps réel',
    company: 'Entreprise',
    last_modified: 'Dernière modification',
    owner: 'Propriétaire',
    integration: "L'intégration",
    installed_integration: 'Intégration installée',
    preferences: 'Préférences',
    search_lead_number: "Recherche des contacts lors d'appels",
    no_integration: 'Aucune intégration installée',
    search_lead_tooltip:
        "Recherche et affiche les informations des contacts du CRM intégré lors d'un appel sortant et entrant",
    records_found: 'Contacts trouvés',
    no_records_found: 'Aucun contact trouvé',
    create: 'Ajouter',
    search_kavkomcrm_only: 'Recherche de contact exclusivement dans le CRM Kavkom',
    search_kavkomcrm_tooltip: "Remplace la recherche de piste dans d'autres intégrations CRM installées",
    kavkom_crm: 'Kavkom CRM',
    manage_conference: 'Gérer',
}
